import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Notifications from 'vue-notification'


Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(Notifications)
new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");
